import { Link } from 'react-router-dom';
import { categories, siteInfo, timeSlots } from '@/mocks/feed';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden bg-primary-950 text-foreground-900">
      <div className="night-grain absolute inset-0 opacity-40" />
      <div className="relative mx-auto w-full max-w-[1440px] px-4 pt-14 pb-8 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 lg:gap-12">
          <div className="md:col-span-5 lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-white">
                <i className="ri-moon-clear-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">{siteInfo.slogan}。{siteInfo.desc}</p>
            <a
              href={`mailto:${siteInfo.email}`}
              className="mt-5 inline-flex items-center gap-2 rounded-md border border-foreground-950/20 px-3.5 py-2 text-sm text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              <i className="ri-mail-line" />
              {siteInfo.email}
            </a>
          </div>

          <nav className="md:col-span-3 lg:col-span-3" aria-label="页脚导航">
            <h4 className="font-label text-xs tracking-[0.25em] text-accent-400 uppercase">站内导航</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/" className="text-foreground-700 transition-colors hover:text-foreground-950">首页</Link>
              </li>
              <li>
                <Link to="/feed" className="text-foreground-700 transition-colors hover:text-foreground-950">瓜田情报库</Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-700 transition-colors hover:text-foreground-950">关于我们</Link>
              </li>
              <li>
                <Link to="/#subscribe" className="text-foreground-700 transition-colors hover:text-foreground-950">深夜订阅</Link>
              </li>
            </ul>
          </nav>

          <nav className="md:col-span-4 lg:col-span-3" aria-label="栏目分类">
            <h4 className="font-label text-xs tracking-[0.25em] text-accent-400 uppercase">栏目分类</h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {categories.map((cat) => (
                <li key={cat}>
                  <Link
                    to={`/feed?cat=${encodeURIComponent(cat)}`}
                    className="inline-block rounded-full border border-foreground-950/15 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-200"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:col-span-12 lg:col-span-2">
            <h4 className="font-label text-xs tracking-[0.25em] text-accent-400 uppercase">值夜时段</h4>
            <ul className="mt-4 space-y-2 text-xs text-foreground-700">
              {timeSlots.map((s) => (
                <li key={s.key} className="flex items-center justify-between gap-2">
                  <span className="whitespace-nowrap">{s.key}</span>
                  <span className="text-foreground-800/70">{s.range}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-foreground-950/15 pt-6 text-xs text-foreground-700 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteInfo.name}. 整理内容仅供娱乐参考，不对任何真实个人作出指向性描述。</p>
          <p className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-foreground-950">内容原则</Link>
            <Link to="/about#faq" className="transition-colors hover:text-foreground-950">常见问题</Link>
            <span>本页内容定时更新</span>
          </p>
        </div>
      </div>
    </footer>
  );
}